// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".links[data-v-f1274adc]{align-items:center;display:flex;justify-content:space-between}.delimeter[data-v-f1274adc]{background-color:#000;height:34px;width:1px}.link[data-v-f1274adc]{color:#000;display:flex;font-size:17px;gap:8px}.icon[data-v-f1274adc]{display:inline-block;padding-top:2px;width:23px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
